module.exports = require('./accessors').RGBAccessor;